<template>
    <div>
        <small>404</small>
        <h2>Pagina no encontrada</h2>
    </div>
</template>